var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4279 84.2551L90.1594 91.8082C93.4986 92.5344 96.7943 90.4161 97.5204 87.0769L108.173 38.0935C108.899 34.7543 106.781 31.4587 103.442 30.7325L68.7101 23.1794C65.3709 22.4532 62.0752 24.5715 61.349 27.9107L50.6966 76.894C49.9704 80.2332 52.0887 83.5289 55.4279 84.2551Z",
    fill: "url(#paint0_linear_1172_4129)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3498 28.4779L67.2317 27.7998L66.5536 30.9179L69.6717 31.5961L70.3498 28.4779Z",
    fill: "#F02B0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9952 29.4877L71.8771 28.8096L71.199 31.9277L74.3171 32.6058L74.9952 29.4877Z",
    fill: "#F05212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6406 30.4984L76.5225 29.8203L75.8444 32.9385L78.9625 33.6166L79.6406 30.4984Z",
    fill: "#F28916"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.286 31.5082L81.1678 30.8301L80.4897 33.9482L83.6079 34.6263L84.286 31.5082Z",
    fill: "#F1A417"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9314 32.5189L85.8133 31.8408L85.1352 34.959L88.2533 35.6371L88.9314 32.5189Z",
    fill: "#D9B717"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5768 33.5287L90.4586 32.8506L89.7805 35.9687L92.8986 36.6468L93.5768 33.5287Z",
    fill: "#D2D325"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2222 34.5394L95.104 33.8613L94.4259 36.9795L97.5441 37.6576L98.2222 34.5394Z",
    fill: "#B1C519"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.868 35.5492L99.7494 34.8711L99.0713 37.9892L102.189 38.6673L102.868 35.5492Z",
    fill: "#9CCF14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0824 112.144L83.3734 102.792C86.6702 101.893 88.6139 98.4914 87.7148 95.1946L74.5254 46.8326C73.6263 43.5357 70.2248 41.592 66.9279 42.4911L32.637 51.843C29.3401 52.7422 27.3964 56.1437 28.2955 59.4405L41.4849 107.803C42.384 111.099 45.7855 113.043 49.0824 112.144Z",
    fill: "url(#paint1_linear_1172_4129)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5398 55.7844L33.4612 56.624L34.3008 59.7026L37.3794 58.863L36.5398 55.7844Z",
    fill: "#F02B0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1262 54.5334L38.0476 55.373L38.8872 58.4516L41.9658 57.612L41.1262 54.5334Z",
    fill: "#F05212"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7127 53.2825L42.6342 54.1221L43.4738 57.2007L46.5523 56.3611L45.7127 53.2825Z",
    fill: "#F28916"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2992 52.0315L47.2206 52.8711L48.0602 55.9497L51.1388 55.1101L50.2992 52.0315Z",
    fill: "#C0A3D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8856 50.7805L51.807 51.6201L52.6466 54.6987L55.7252 53.8591L54.8856 50.7805Z",
    fill: "#C0A3D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4721 49.5295L56.3936 50.3691L57.2332 53.4477L60.3117 52.6081L59.4721 49.5295Z",
    fill: "#C0A3D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0586 48.2795L60.98 49.1191L61.8196 52.1977L64.8982 51.3581L64.0586 48.2795Z",
    fill: "#C0A3D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.645 47.0286L65.5664 47.8682L66.406 50.9467L69.4846 50.1071L68.645 47.0286Z",
    fill: "#C0A3D3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.754 32.0826C114.119 32.0826 115.227 30.9754 115.227 29.6096C115.227 28.2439 114.119 27.1367 112.754 27.1367C111.388 27.1367 110.281 28.2439 110.281 29.6096C110.281 30.9754 111.388 32.0826 112.754 32.0826Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3067 18.2627C86.0261 18.2627 86.6094 17.6795 86.6094 16.96C86.6094 16.2405 86.0261 15.6572 85.3067 15.6572C84.5872 15.6572 84.0039 16.2405 84.0039 16.96C84.0039 17.6795 84.5872 18.2627 85.3067 18.2627Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2129 39.919C49.6476 39.919 50 39.5666 50 39.1318C50 38.6971 49.6476 38.3447 49.2129 38.3447C48.7782 38.3447 48.4258 38.6971 48.4258 39.1318C48.4258 39.5666 48.7782 39.919 49.2129 39.919Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2578 29.7207C51.5393 29.7207 52.5781 28.6819 52.5781 27.4004C52.5781 26.1189 51.5393 25.0801 50.2578 25.0801C48.9763 25.0801 47.9375 26.1189 47.9375 27.4004C47.9375 28.6819 48.9763 29.7207 50.2578 29.7207Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 67.4932L20.6094 66.2041L19.3203 67.4932L20.6094 68.7822L21.8984 67.4932Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 46.3525L19.0625 45.0635L17.7734 46.3525L19.0625 47.6416L20.3516 46.3525Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.461 15.4639L104.742 17.5825C104.524 17.8503 104.524 18.2337 104.742 18.5015L106.461 20.6201L104.342 18.901C104.074 18.6837 103.691 18.6837 103.423 18.901L101.305 20.6201L103.024 18.5015C103.241 18.2337 103.241 17.8503 103.024 17.5825L101.305 15.4639L103.423 17.183C103.691 17.4003 104.074 17.4003 104.342 17.183L106.461 15.4639Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.539 18.0424L104.244 18.4033L103.883 25.699L103.522 18.4033L96.2262 18.0424L103.522 17.6814L103.883 10.3857L104.244 17.6814L111.539 18.0424Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.419 90.2061L110.509 92.5602C110.268 92.8578 110.268 93.2838 110.509 93.5813L112.419 95.9355L110.065 94.0252C109.768 93.7838 109.342 93.7838 109.044 94.0252L106.69 95.9355L108.6 93.5813C108.842 93.2838 108.842 92.8578 108.6 92.5602L106.69 90.2061L109.044 92.1163C109.342 92.3578 109.768 92.3578 110.065 92.1163L112.419 90.2061Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M118.062 93.0703L109.956 93.4714L109.555 101.578L109.154 93.4714L101.047 93.0703L109.154 92.6692L109.555 84.5625L109.956 92.6692L118.062 93.0703Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5772 32.6114L33.3066 30.3408L31.036 32.6114L33.3066 34.882L35.5772 32.6114Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3066 21.2676L33.6773 30.7116H32.936L33.3066 21.2676Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3067 43.9L33.6773 34.4561H32.936L33.3067 43.9Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.623 32.5835L35.1791 32.2129V32.9542L44.623 32.5835Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 32.5835L31.4342 32.2129V32.9542L21.9902 32.5835Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4728 98.8272C83.7995 98.8272 93.7922 88.8344 93.7922 76.5078C93.7922 64.1812 83.7995 54.1885 71.4728 54.1885C59.1462 54.1885 49.1535 64.1812 49.1535 76.5078C49.1535 88.8344 59.1462 98.8272 71.4728 98.8272Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3141 115.032L98.2333 114.4C99.2487 113.701 99.5052 112.311 98.8063 111.296L86.406 93.2812L84.204 95.0026L81.8099 96.445L94.2101 114.459C94.909 115.475 96.2987 115.731 97.3141 115.032Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1172_4129",
    x1: 86.8999,
    y1: 24.0055,
    x2: 69.9318,
    y2: 100.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C6DB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176212,
    stopColor: "#996AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326028,
    stopColor: "#9064A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466264,
    stopColor: "#805A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600621,
    stopColor: "#6B4B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730872,
    stopColor: "#50375C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858008,
    stopColor: "#2E2035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98038,
    stopColor: "#060408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1172_4129",
    x1: 49.1498,
    y1: 44.1697,
    x2: 69.2778,
    y2: 119.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C6DB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176212,
    stopColor: "#996AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326028,
    stopColor: "#9064A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466264,
    stopColor: "#805A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600621,
    stopColor: "#6B4B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730872,
    stopColor: "#50375C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858008,
    stopColor: "#2E2035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98038,
    stopColor: "#060408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.ba11c0e06e5440e88ada284024eabf60.svg";
export { ForwardRef as ReactComponent };